var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ym-price",class:[
        ("ym-price-size-" + _vm.size),
        ("ym-price-type-" + _vm.type),
        { 'is-del': _vm.del },
        { 'is-string': !_vm.isNumber } ]},[_vm._t("default"),_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }